import UsersServices from "@/services/UserServices";
import handleAlert from "@/utils/HandleAlert";
import { removePage, setPage } from "@/utils/HandleToken";

export default {
  namespaced: true,
  state: {
    form: {},

    search: "",
    limit: 10,

    users: [],
    pagination: {},

    userDetail: {},
  },
  mutations: {
    SET_FORM(state, value) {
      state.form = value;
    },
    SET_USERS(state, value) {
      state.users = value;
    },
    SET_PAGINATION(state, value) {
      state.pagination = value;
    },
    SET_SEARCH(state, value) {
      state.search = value;
    },
    SET_USER_DETAIL(state, value) {
      state.userDetail = value;
    },
  },
  actions: {
    async saveCreate({ commit, state, rootState, dispatch }) {
      state.form.ucreated = rootState.Auth.userData.username;
      try {
        const result = await UsersServices.create(state.form);
        handleAlert({ commit, dispatch }, result, null);
        commit("SET_FORM", {});
        dispatch("readAll", state.pagination.currentPage);
      } catch (error) {
        handleAlert({ commit, dispatch }, null, error);
      }
    },
    async readAll({ commit, state, dispatch }, payload) {
      removePage();
      const form = {
        search: state.search,
        pagination: {
          limit: state.limit,
          page: payload,
        },
      };
      try {
        const result = await UsersServices.findAll(form);
        commit("SET_USERS", result.data.data);
        commit("SET_PAGINATION", result.data.pagination);
      } catch (error) {
        handleAlert({ commit, dispatch }, null, error);
      } finally {
        setPage(payload);
      }
    },
    async readOne({ commit, dispatch }, payload) {
      try {
        const result = await UsersServices.findOne({ usercode: payload });
        commit("SET_USER_DETAIL", result.data);
      } catch (error) {
        handleAlert({ commit, dispatch }, null, error);
      }
    },
    async delete({ commit, state, dispatch }, payload) {
      try {
        const { id, closeModal } = payload;
        const result = await UsersServices.delete({ usercode: id });
        handleAlert({ commit, dispatch }, result, null);
        if (result.meta.code == 201) {
          dispatch("readAll", state.pagination.currentPage);
          closeModal.click();
        }
      } catch (error) {
        handleAlert({ commit, dispatch }, null, error);
      }
    },
    async update({ commit, state, dispatch }, payload) {
      try {
        const result = await UsersServices.update(payload);
        handleAlert({ commit, dispatch }, result, null);
        if (result.meta.code === 201) {
          commit("SET_USER_DETAIL", result.data);
          dispatch("readAll", state.pagination.currentPage);
        }
      } catch (error) {
        handleAlert({ commit, dispatch }, null, error);
      }
    },
  },
  getters: {},
};
